import AccountTreeOutlinedIcon from '@mui/icons-material/AccountTreeOutlined';
import InfoIcon from '@mui/icons-material/InfoOutlined';
import PentagonOutlinedIcon from '@mui/icons-material/PentagonOutlined';
import PeopleIcon from '@mui/icons-material/PeopleOutlineTwoTone';
import PlanIcon from '@mui/icons-material/PolicyOutlined';
import React, {useEffect, useState} from 'react';
import SidebarListItem from './SidebarListItem';
import routePath, {Routes} from '@account/utils/route';
import {Collapse, List, styled} from '@mui/material';
import {hasRoleLevel, roleLevels} from '@account/utils';
import {lightGrey} from '@account/styles';
import {useAuth} from '@apps-common/auth-react';
import {useFlags} from '@hooks/useFlags';
import {useParams} from 'react-router-dom';

const StyledList = styled(List)({
  borderBottom: `solid 1px ${lightGrey}`,
});

const OrganizationSidebar = () => {
  const auth = useAuth();
  const {orgId} = useParams();
  const [open, setOpen] = useState(false);

  const {oneClickProvisioningIsActive} = useFlags();

  useEffect(() => setOpen(true), [setOpen]);

  const isPlanetAdmin = hasRoleLevel(auth, [roleLevels.planet_admin]);

  return orgId !== 'undefined' ? (
    <Collapse in={open}>
      <StyledList disablePadding>
        <SidebarListItem
          nested
          to={routePath(Routes.ORG_GENERAL, {orgId})}
          icon={<InfoIcon color="disabled" fontSize="small" />}
          text="General"
          id="organization-general"
          exact
        />

        <SidebarListItem
          nested
          to={routePath(Routes.ORG_USERS, {orgId})}
          icon={<PeopleIcon color="disabled" fontSize="small" />}
          text="Users"
          id="organization-users"
          exact
        />

        <SidebarListItem
          nested
          to={routePath(Routes.ORG_SUBORGS, {orgId})}
          icon={<AccountTreeOutlinedIcon color="disabled" fontSize="small" />}
          text="Sub Organizations"
          id="organization-subOrgs"
          exact
        />

        <SidebarListItem
          nested
          to={routePath(Routes.ORG_PLANS, {orgId})}
          icon={<PlanIcon color="disabled" fontSize="small" />}
          text="Plans"
          id="organization-plans"
        />

        {isPlanetAdmin && !oneClickProvisioningIsActive && (
          <SidebarListItem
            nested
            to={routePath(Routes.ORG_AOA, {orgId})}
            icon={
              <PentagonOutlinedIcon
                color="disabled"
                fontSize="small"
                sx={{transform: 'rotate(45deg)'}}
              />
            }
            text="Areas of Access"
            id="areas-of-access"
          />
        )}
      </StyledList>
    </Collapse>
  ) : (
    <p>not found </p>
  );
};

export default OrganizationSidebar;
